module.exports = __webpack_public_path__ + "static/media/right-arrow.57d8ae5a.svg";